import { jsx as _jsx } from "react/jsx-runtime";
import { useDndContext } from "@dnd-kit/core";
import noop from "lodash/noop";
import { memo, useEffect, useRef } from "react";
import { AutoSizer } from "react-virtualized";
import { VariableSizeList } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";
import { currentKanbanGroupByCustomFieldIdSelector } from "~/store/configViews/selectors";
import { useAirSelector } from "~/utils/ReduxUtils";
import { useRenderKanbanColumn } from "./useRenderKanbanColumn";
export const KanbanHorizontalColumnsScroller = /*#__PURE__*/ memo((param)=>{
    let { loadNextColumnGroup } = param;
    const customFieldId = useAirSelector(currentKanbanGroupByCustomFieldIdSelector);
    const listRef = useRef(null);
    const { isColumnLoaded, kanbanColumnIds, renderKanbanColumn, getColumnWidth } = useRenderKanbanColumn();
    const { over } = useDndContext();
    useEffect(()=>{
        var // redraw widths of columns
        _listRef_current;
        listRef === null || listRef === void 0 ? void 0 : (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.resetAfterIndex(0, false);
    }, [
        over,
        kanbanColumnIds,
        customFieldId
    ]);
    return /*#__PURE__*/ _jsx(AutoSizer, {
        children: (param)=>{
            let { height, width } = param;
            return /*#__PURE__*/ _jsx(InfiniteLoader, {
                isItemLoaded: isColumnLoaded,
                itemCount: kanbanColumnIds.length,
                loadMoreItems: loadNextColumnGroup || noop,
                threshold: 0,
                minimumBatchSize: 1,
                children: (param)=>{
                    let { onItemsRendered, ref } = param;
                    return /*#__PURE__*/ _jsx(VariableSizeList, {
                        className: "no-scrollbar",
                        height: height,
                        width: width,
                        itemCount: kanbanColumnIds.length,
                        itemSize: getColumnWidth,
                        layout: "horizontal",
                        onItemsRendered: onItemsRendered,
                        ref: (el)=>{
                            listRef.current = el;
                            // need to use their ref because it is used under the hood
                            // @ts-ignore their ref is `setRef(el: any) => void`
                            ref(el);
                        },
                        children: renderKanbanColumn
                    });
                }
            });
        }
    });
});
KanbanHorizontalColumnsScroller.displayName = "KanbanHorizontalColumnsScroller";
